import { queryOptions } from "@tanstack/react-query";

import clientV3SDK from "~/api/clientV3SDK";
import { QUERY_REFETCH_INTERVAL_MS_30S } from "~/constants";

export const notificationPollingQueryKeys = {
  list: () => ["notifications", "list"] as const,
};

export const notificationPollingQueryOptions = {
  list: () =>
    queryOptions({
      queryKey: notificationPollingQueryKeys.list(),
      queryFn: () => clientV3SDK.listNotifications(),
      refetchInterval: QUERY_REFETCH_INTERVAL_MS_30S,
    }),
};
